"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionalContactDetails = exports.DefaultContactDetails = void 0;
const tslib_1 = require("tslib");
const config_1 = tslib_1.__importDefault(require("@iotv/config"));
const Address_1 = require("./Address");
exports.DefaultContactDetails = {
    email: {
        type: 'String',
        editable: true,
        required: true,
        validation: {
            regex: config_1.default.app.regex.email,
            pass: true,
            invalidMessage: 'Not a valid email address',
        },
    },
    ...Address_1.Address,
    phoneNumber: {
        type: 'String',
        editable: true,
        required: true,
        validation: {
            regex: /^[0-9\+ ]+$/,
            pass: true,
            invalidMessage: 'Phone number invalid',
        },
    },
};
exports.OptionalContactDetails = {
    email: {
        ...exports.DefaultContactDetails.email,
        required: false,
    },
    ...Address_1.Address,
    phoneNumber: {
        ...exports.DefaultContactDetails.phoneNumber,
        required: false,
    },
};
